import { Bike, Users, Info } from "lucide-react";
import { useMarket } from "../../lib/market";

function PriceTable({ tiers, bikes }) {
  const { price, priceNote } = useMarket();
  return (
    <section className="grid sm:grid-cols-2 gap-8" data-testid="tour-price-tiers">
      <div>
        <h2 className="font-display font-bold text-lg tracking-tight mb-3 flex items-center gap-2"><Users className="w-4 h-4 text-moss" /> Price by group size</h2>
        <ul className="border border-sand-dark rounded-md bg-white divide-y divide-sand-dark">
          {tiers.map((t, i) => (
            <li key={t.label} className="flex justify-between px-4 py-3 text-sm" data-testid={`price-tier-${i}`}>
              <span className="text-ink-secondary">{t.label}</span>
              <span className="font-semibold">{t.price ? `${price(t.price)} pp` : "Not priced"}</span>
            </li>
          ))}
        </ul>
        {priceNote && <p className="text-[11px] text-ink-muted mt-1.5">{priceNote}</p>}
      </div>
      {bikes?.length > 0 && (
        <div>
          <h2 className="font-display font-bold text-lg tracking-tight mb-3 flex items-center gap-2"><Bike className="w-4 h-4 text-moss" /> Optional bike hire</h2>
          <ul className="border border-sand-dark rounded-md bg-white divide-y divide-sand-dark">
            {bikes.map((b, i) => (
              <li key={b.name} className="flex justify-between gap-3 px-4 py-3 text-sm" data-testid={`bike-hire-${i}`}>
                <span className="text-ink-secondary">{b.name}</span>
                <span className="font-semibold whitespace-nowrap">{price(b.price)} pp</span>
              </li>
            ))}
          </ul>
          <p className="text-[11px] text-ink-muted mt-1.5">Or bring your own bike.</p>
        </div>
      )}
    </section>
  );
}

export function RideStats({ stats }) {
  if (!stats?.length) return null;
  return (
    <section data-testid="tour-ride-stats">
      <h2 className="font-display font-bold text-lg tracking-tight mb-3">The ride</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {stats.map((s) => (
          <div key={s.label} className="border border-sand-dark rounded-md bg-white p-3">
            <p className="font-mono text-[10px] uppercase tracking-widest text-ink-muted">{s.label}</p>
            <p className="font-semibold text-sm mt-0.5">{s.value}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export function RiderInfo({ tour }) {
  return (
    <>
      {tour.price_tiers?.length > 0 && <PriceTable tiers={tour.price_tiers} bikes={tour.bike_hire} />}
      {tour.rider_notes?.length > 0 && (
        <section data-testid="tour-rider-notes">
          <h2 className="font-display font-bold text-lg tracking-tight mb-3">Good to know before you ride</h2>
          <ul className="space-y-2">
            {tour.rider_notes.map((n) => (
              <li key={n} className="flex items-start gap-2 text-sm text-ink-secondary"><Info className="w-4 h-4 text-moss shrink-0 mt-0.5" />{n}</li>
            ))}
          </ul>
        </section>
      )}
    </>
  );
}
